export default __webpack_public_path__ + "static/loading-icon-9c2bd4b897cc9d4b8379c6ca338ef2ab.gif";